import React from 'react';
import withSession from '../../lib/withSession';
import { NotSubscribed } from './inner/NotSubscribed';
import Subscribed from './inner/Subscribed';
import { withRouter } from 'react-router-dom';

export const GutResetLanding = withSession(
  withRouter(({ session, history }) => {
    const { isGiMember, eligibility } = session;

    if (!eligibility || !eligibility.canBookNutritionist) {
      history.push('/');
    }

    if (!!isGiMember) return <Subscribed />;
    return <NotSubscribed />;
  })
);
